import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	clone: {
		id: 'eoc.common.ui.date-time-interval.clone',
		defaultMessage: 'Duplicate',
		description: 'Accessibility label of clone interval button',
	},
	delete: {
		id: 'eoc.common.ui.date-time-interval.delete',
		defaultMessage: 'Delete',
		description: 'Accessibility label of delete interval button',
	},
	addNew: {
		id: 'eoc.common.ui.date-time-interval.add-new',
		defaultMessage: 'Add time slot',
		description: 'Label of add new interval button',
	},
});

export default messages;
